import { render } from "./TitleDescriptionField.vue?vue&type=template&id=9e8dd71c"
import script from "./TitleDescriptionField.vue?vue&type=script&lang=js"
export * from "./TitleDescriptionField.vue?vue&type=script&lang=js"

import exportComponent from "c:\\Clients\\VoterFly\\application\\VoterFly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__